module.exports = __webpack_public_path__ + "img/19df2.1aba2073.svg";